import React from 'react';
import { Box } from '@mui/material';
import { Row, Table as TanstackTable } from '@tanstack/react-table';
import { DataRecord } from './table.types';

interface InlineActionsCellProps {
  row: Row<DataRecord>;
  inlineActions: ((dataRow: DataRecord) => React.ReactNode)[];
}

// eslint-disable-next-line react/display-name
const InlineActionsCell = React.memo(({ row, inlineActions }: InlineActionsCellProps) => (
  <Box className="inline-actions-cell">
    {inlineActions?.map(actionFn => (
      <React.Fragment key={actionFn.toString()}>{actionFn(row.original)}</React.Fragment>
    ))}
  </Box>
));
export const InlineActionsCellRenderer = ({ row, table }: { row: Row<DataRecord>; table: TanstackTable<DataRecord> }) => {
  const inlineActions = table.options.meta?.inlineActions || [];
  return <InlineActionsCell row={row} inlineActions={inlineActions} />;
};
